export default "__VITE_ASSET__ej08ui$W__"